<template>
  <div class="sheetBg" :class="style[triggerType].bg">
    <div class="sheet-icon">
      <svg-icon
        :icon-class="style[triggerType].icon.class"
        :style="{ color: style[triggerType].icon.color }"
      ></svg-icon>
    </div>
    <div class="sheetName">{{ style[triggerType].text }}</div>
  </div>
</template>

<script>
export default {
  name: "sheetBg",
  props: {
    triggerType: String
  },
  data() {
    return {
      style: {
        START_TYPE_DATA: {
          icon: {
            color: "#ffa340",
            class: "workflow_trigger_sheet"
          },
          bg: "bg-yellow-trigger",
          text: "工作表"
        },
        START_TYPE_TIME: {
          icon: {
            color: "#2196f3",
            class: "workflow_trigger_time"
          },
          bg: "bg-blue-trigger",
          text: "日期字段"
        },
        START_TYPE_CRON: {
          icon: {
            color: "#2196f3",
            class: "workflow_trigger_cron"
          },
          bg: "bg-blue-trigger",
          text: "定时触发"
        },
        START_TYPE_BTN: {
          icon: {
            color: "#FDAF5A",
            class: "workflow_trigger_button"
          },
          bg: "bg-yellow-trigger",
          text: "按钮触发"
        },
        START_TYPE_TASK: {
          icon: {
            color: "#FDAF5A",
            class: "workflow_trigger_task"
          },
          bg: "bg-yellow-trigger",
          text: "任务触发"
        },
        START_TYPE_SUB: {
          icon: {
            color: "#2196f3",
            class: "workflow_trigger_sub-process"
          },
          bg: "bg-blue-trigger",
          text: "子流程"
        },
        START_TYPE_VALIDATE: {
          icon: {
            color: "#2196f3",
            class: "workflow_trigger_validate"
          },
          bg: "bg-blue-trigger",
          text: "校验"
        },
        START_TYPE_HTTP: {
          icon: {
            color: "#2196f3",
            class: "workflow_trigger_http"
          },
          bg: "bg-blue-trigger",
          text: "网络请求"
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sheetBg {
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  .sheet-icon {
    color: currentColor;
    width: 68px;
    height: 68px;
    background: #fff;
    border-radius: 50%;
    font-size: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sheetName {
    font-size: 17px;
    padding-top: 10px;
  }
}
</style>
